import { Fetcher } from '@pp/core/src/api/Fetcher';

import type { TableTopDataTypes } from './types';

export interface FetchTableTopDataParams {
  'table-id': string;
  category: string;
  period: string;
  url: string;
  JWTTOKEN: string;
  force: boolean;
}

export const fetchTableTopData = ({
  'table-id': tableId,
  category,
  period,
  url,
  JWTTOKEN,
  force,
}: FetchTableTopDataParams): Promise<TableTopDataTypes> => {
  return Fetcher.fetch<TableTopDataTypes>(url, {
    params: {
      'table-id': tableId,
      category,
      period,
      JWTTOKEN,
    },
    force: force,
  });
};
